module.exports = __webpack_public_path__ + "static/img/no_service.d7007d6b.png";